import { FieldType } from 'controls/queryBuilder/ruleDefinition';

import { BindableVariable } from '../types';

export function isVariableSuitable({ type, multiple }: BindableVariable, fieldType: FieldType, list: boolean) {
	if (multiple && !list && fieldType != FieldType.Text) {
		return false;
	}

	switch (fieldType) {
		case FieldType.Text:
			return true;
		case FieldType.Number:
			return type == FieldType.Number;
		case FieldType.Date:
			return type == FieldType.Date || type == FieldType.Number;
		case FieldType.Boolean:
			return type == FieldType.Boolean;
		default:
			return type != FieldType.Boolean;
	}
}
